import { render, staticRenderFns } from "./accountManagement.vue?vue&type=template&id=5a0fa0b3&scoped=true&"
import script from "./accountManagement.vue?vue&type=script&lang=js&"
export * from "./accountManagement.vue?vue&type=script&lang=js&"
import style0 from "./accountManagement.vue?vue&type=style&index=0&id=5a0fa0b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fa0b3",
  null
  
)

export default component.exports